/**
 * Registers a document-level pointerdown listener that closes the given popover
 * when clicking outside the host element. Listener is managed via the popover's
 * toggle event - added on open, removed on close.
 *
 * Use this for popover="manual" elements that lack native light-dismiss.
 */
export function setupOutsideClickHandler(host: HTMLElement, popover: HTMLElement): void {
    let handler: ((evt: Event) => void) | null = null;

    popover.addEventListener('toggle', (e: Event) => {
        const toggleEvent = e as ToggleEvent;
        if (toggleEvent.newState === 'open') {
            handler = (evt: Event) => {
                if (!host.contains(evt.target as Node)) {
                    popover.hidePopover();
                }
            };
            document.addEventListener('pointerdown', handler);
        } else if (handler) {
            document.removeEventListener('pointerdown', handler);
            handler = null;
        }
    });
}

/**
 * Closes all currently open o2d-popover-list elements except the given one.
 * Call before showPopover() to ensure only one popover-list is visible at a time.
 */
export function closeOtherPopovers(except?: HTMLElement): void {
    document.querySelectorAll('o2d-popover-list:popover-open').forEach(p => {
        if (p !== except) (p as HTMLElement).hidePopover();
    });
}
